import { render } from "./experts.vue?vue&type=template&id=6f6a9d61&scoped=true"
import script from "./experts.vue?vue&type=script&lang=js"
export * from "./experts.vue?vue&type=script&lang=js"

import "./experts.vue?vue&type=style&index=0&id=6f6a9d61&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6a9d61"]])

export default __exports__